import React from "react";
import Modal from "react-modal";
import "../../css/BaseModal.css";

/**
 * A reusable modal component that wraps React Modal for consistency in styling and behaviour across the app.
 *
 * @component
 * @param {Boolean} isOpen - Controls whether the modal is open or closed.
 * @param {Function} onRequestClose - Callback function triggered when the closen button is clicked or if the user clicks outside the modal.
 * @param {ReactNode} children - Content to display inside the modal, such as text, forms, or other components.
 * @param {String} [width='auto'] - Optional width of the modal content, defaults to 'auto' if not provided.
 *
 * @returns {JSX.Element} The rendered BaseModal component.
 */
const BaseModal = ({ isOpen, onRequestClose, children, width }) => {
  return (
    <Modal
      className="modal-content"
      overlayClassName="modal-overlay"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        content: {
          width: width || "auto", // Defaults to 'auto' if width prop is not provided
        },
      }}
    >
      <button className="modal-close-button" onClick={onRequestClose}>
        X
      </button>
      {children}
    </Modal>
  );
};

export default BaseModal;
